module.exports = __webpack_public_path__ + "img/may_1248.1f784c9d.png";